<template>
	<v-card flat class="mt-6 background-2">
		<v-card-title class="text-subtitle-1">
			<v-icon left small>mdi-history</v-icon>
			Attività Recenti
			<v-spacer></v-spacer>
			<v-select
				v-model="activityFilter"
				:items="activityActions"
				label="Filtra"
				dense outlined hide-details clearable
				:menu-props="{'offset-y': true}"
				style="max-width: 200px"
				class="mr-2 d-none d-sm-inline-flex"
				v-show="activityExpand"
			></v-select>
			<v-text-field
				v-model="activitySearch"
				append-icon="mdi-magnify"
				label="Cerca"
				dense outlined hide-details clearable
				style="max-width: 200px"
				class="mr-2 d-none d-sm-inline-flex"
				v-show="activityExpand"
				@input="debouncedActivitySearch"
			></v-text-field>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="loadActivity()" icon>
						<v-icon>mdi-refresh</v-icon>
					</v-btn>
				</template>
				<span>Refresh</span>
			</v-tooltip>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="activityExpand = !activityExpand" icon>
						<v-icon>{{ activityExpand ? 'expand_less' : 'expand_more' }}</v-icon>
					</v-btn>
				</template>
				<span>{{ activityExpand ? 'Contrai' : 'Espandi' }}</span>
			</v-tooltip>
		</v-card-title>
		<!-- Mobile: filtro e cerca sotto il titolo -->
		<v-row v-show="activityExpand" class="d-sm-none px-4 pb-2" no-gutters>
			<v-col cols="6" class="pr-1">
				<v-select
					v-model="activityFilter"
					:items="activityActions"
					label="Filtra"
					dense outlined hide-details clearable
					:menu-props="{'offset-y': true}"
				></v-select>
			</v-col>
			<v-col cols="6" class="pl-1">
				<v-text-field
					v-model="activitySearch"
					append-icon="mdi-magnify"
					label="Cerca"
					dense outlined hide-details clearable
					@input="debouncedActivitySearch"
				></v-text-field>
			</v-col>
		</v-row>
		<v-expand-transition>
			<div v-show="activityExpand">
				<v-divider></v-divider>
				<v-data-table
					:headers="activityHeaders"
					:items="activity"
					:options.sync="activityPagination"
					:server-items-length="activityTotal"
					:loading="activityLoading"
					dense
					:footer-props="{
						'items-per-page-options': [10, 25, 50],
						showFirstLastPage: true
					}"
					class="background-2 dms-activity-table"
				>
					<template v-slot:item.icon="{ item }">
						<v-icon small :color="getActionColor(item.action)">{{ getActionIcon(item.action) }}</v-icon>
					</template>
					<template v-slot:item.created_at="{ item }">
						{{ item.created_at | date }}
					</template>
					<template v-slot:item.user="{ item }">
						{{ item.user ? item.user.name : '-' }}
					</template>
					<template v-slot:item.action="{ item }">
						{{ getActionLabel(item.action) }}
					</template>
					<template v-slot:item.details="{ item }">
						{{ item.details && item.details.name ? (item.attachment && item.attachment.ext ? $options.filters.fileName(item.details.name, item.attachment.ext) : item.details.name) : '' }}
					</template>
					<template v-slot:no-data>
						<div class="text-center grey--text pa-4">Nessuna attività</div>
					</template>
				</v-data-table>
			</div>
		</v-expand-transition>
	</v-card>
</template>

<script>
export default {
	name: 'DmsRecentActivity',
	props: {
		apiBase: { type: String, required: true }
	},
	data() {
		return {
			activity: [],
			activityTotal: 0,
			activityFilter: null,
			activitySearch: '',
			activitySearchTimeout: null,
			activityExpand: true,
			activityLoading: false,
			activityPagination: { page: 1, itemsPerPage: 10 }
		}
	},
	computed: {
		activityActions() {
			return [
				{ text: 'Caricamento', value: 'uploaded' },
				{ text: 'Download', value: 'downloaded' },
				{ text: 'Rinominato', value: 'renamed' },
				{ text: 'Spostato', value: 'moved' },
				{ text: 'Eliminato', value: 'deleted' },
				{ text: 'Tag modificato', value: 'tagged' },
				{ text: 'Nuova versione', value: 'version_uploaded' },
			]
		},
		activityHeaders() {
			return [
				{ text: '', value: 'icon', sortable: false, width: '40px' },
				{ text: 'Data', value: 'created_at', sortable: false },
				{ text: 'Utente', value: 'user', sortable: false },
				{ text: 'Azione', value: 'action', sortable: false },
				{ text: 'Dettaglio', value: 'details', sortable: false },
			]
		}
	},
	watch: {
		activityFilter() {
			this.activityPagination.page = 1
			this.loadActivity()
		},
		activityPagination: {
			deep: true,
			handler() {
				this.loadActivity()
			}
		}
	},
	created() {
		this.loadActivity()
	},
	methods: {
		reload() {
			this.loadActivity()
		},
		debouncedActivitySearch() {
			clearTimeout(this.activitySearchTimeout)
			this.activitySearchTimeout = setTimeout(() => {
				this.activityPagination.page = 1
				this.loadActivity()
			}, 400)
		},
		async loadActivity() {
			this.activityLoading = true
			try {
				var params = {
					page: this.activityPagination.page,
					rowsPerPage: this.activityPagination.itemsPerPage
				}
				if (this.activityFilter) params.action = this.activityFilter
				if (this.activitySearch) params.search = this.activitySearch
				var resp = await this.axios.get(this.apiBase + '/activity', { params })
				if (resp.data.success) {
					this.activity = resp.data.data || []
					this.activityTotal = resp.data.total || 0
				}
			} catch (e) {
				// silent
			}
			this.activityLoading = false
		},
		getActionLabel(action) {
			const map = {
				viewed: 'Visualizzazione', downloaded: 'Download', uploaded: 'Caricamento',
				renamed: 'Rinominato', moved: 'Spostato', deleted: 'Eliminato',
				tagged: 'Tag modificato', version_uploaded: 'Nuova versione', logged_in: 'Accesso',
				shared: 'Condivisione', unshared: 'Rimossa condivisione'
			}
			return map[action] || action
		},
		getActionIcon(action) {
			const map = {
				viewed: 'mdi-eye', downloaded: 'mdi-download', uploaded: 'mdi-upload',
				renamed: 'mdi-pencil', moved: 'mdi-folder-move', deleted: 'mdi-delete',
				tagged: 'mdi-tag', version_uploaded: 'mdi-file-replace', logged_in: 'mdi-login',
				shared: 'mdi-share-variant', unshared: 'mdi-share-off'
			}
			return map[action] || 'mdi-information'
		},
		getActionColor(action) {
			const map = {
				uploaded: 'green', downloaded: 'blue', deleted: 'red',
				renamed: 'orange', moved: 'purple', tagged: 'teal',
				version_uploaded: 'indigo', logged_in: 'primary',
				shared: 'cyan', unshared: 'grey', viewed: 'grey'
			}
			return map[action] || 'grey'
		}
	}
}
</script>

